import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { services } from "@/config/site";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 md:py-36 overflow-hidden"
    >
      <div
        className="vs-orb"
        style={{
          width: 600,
          height: 600,
          top: 100,
          right: -260,
          background: "var(--vs-ambient-purple)",
        }}
      />
      <div className="vs-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-[#d4af37]" />
              <span className="text-overline">Nine Advisory Pillars</span>
            </div>
            <h2 className="mt-5 font-serif-display text-4xl md:text-6xl leading-[1.02] text-white tracking-tight">
              Services engineered
              <br />
              for <span className="italic vs-gold-text">owner-level</span> decisions.
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-5 text-white/70 font-body leading-relaxed max-w-md"
          >
            Nine pillars. One outcome — clarity on what is driving profit, cash, growth
            and risk in your business, and what to do next.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {services.map((s, idx) => (
            <motion.article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (idx % 3) * 0.08 }}
              whileHover={{ y: -4 }}
              className={`group relative vs-glass rounded-sm p-7 md:p-8 flex flex-col justify-between min-h-[280px] hover:border-[#d4af37]/50 transition-colors ${s.span || ""}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-mono-accent text-xs text-[#d4af37] tracking-[0.25em]">
                  {s.number}
                </span>
                <ArrowUpRight
                  size={18}
                  className="text-white/30 group-hover:text-[#d4af37] transition-colors group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform"
                />
              </div>

              <div className="mt-14">
                <h3 className="font-serif-display text-2xl md:text-3xl text-white leading-tight tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm md:text-[15px] text-white/65 font-body leading-relaxed">
                  {s.short}
                </p>
              </div>

              <ul className="mt-6 pt-5 border-t border-white/10 space-y-1.5">
                {s.bullets.map((b) => (
                  <li
                    key={b}
                    className="text-[12px] tracking-wide text-white/50 font-body flex items-center gap-2"
                  >
                    <span className="h-1 w-1 bg-[#d4af37] rounded-full" />
                    {b}
                  </li>
                ))}
              </ul>

              {/* corner gold glow */}
              <div
                aria-hidden
                className="pointer-events-none absolute -bottom-16 -right-16 h-40 w-40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{ background: "radial-gradient(circle, rgba(212,175,55,0.18), transparent 70%)" }}
              />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
